import { memo, type KeyboardEvent } from "react";
import { GalleryImageObject } from "../Galleries/utils/utils";
import { imageProfileGenerator } from "@/utils/image/imageProfileGenerator";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import styles from "./Gallery.module.scss";

type GalleryImageProps = {
  mediaItem: GalleryImageObject;
  index: number;
  total: number;
  sizes?: string;
  onSelect: (index: number, isImage: true) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
};

export const GalleryImage = memo(function GalleryImage({
  mediaItem,
  index,
  total,
  sizes = "100vw",
  onSelect: onClickZoom,
  onKeyDown,
}: GalleryImageProps) {
  return (
    <button
      className={styles.imageButton}
      onClick={() => onClickZoom(index, true)}
      type="button"
      aria-label={`View full size image ${index + 1} of ${total}, ${mediaItem.title}`}
      data-testid={`gallery:image-${index}`}
      onKeyDown={onKeyDown}
    >
      <img
        src={formatAmplienceImageURL(mediaItem.imageUrl)}
        alt=""
        className={styles.image}
        sizes={sizes}
        srcSet={imageProfileGenerator(mediaItem.imageUrl)}
        loading={index > 1 ? "lazy" : "eager"}
        fetchPriority={index === 0 ? "high" : "auto"}
      />
    </button>
  );
});
